/// <amd-module name="VSSUI/TeachingPanel" />
export * from "./Components/TeachingPanel/TeachingPanel";
export { ITeachingPanelProps, ITeachingSlideProps } from "./Components/TeachingPanel/TeachingPanel.Props";
